import apiClient from './apiClient';

// Weinstein weekly stages (DWLF-382): GET /stages/{symbol} → { symbol, stage, stageName, weeksInStage, since,
// rulesVersion, verification, history: [{ to, from, baseline, knowableFrom, close }] }. `stage: null` with
// reason 'no-stage' = no qualifying row. A 500 is a data fault the caller shows, never an empty stage.
export const stagesAPI = {
  getStage: async (symbol) => {
    if (!symbol) {
      throw new Error('stagesAPI.getStage: symbol is required');
    }
    const response = await apiClient.get(`/stages/${encodeURIComponent(String(symbol).replace('/', '-'))}`);
    return response.data?.data ?? response.data;
  },
};

export default stagesAPI;
